(function () {
  function formatTimerValue(value) {
    return String(value).padStart(2, '0');
  }

  function initSaleBannerCountdown(root = document) {
    const timers = root.querySelectorAll('[data-pdp-sale-banner-v3-countdown]');

    timers.forEach((timer) => {
      if (timer.dataset.timerInit === 'true') return;

      timer.dataset.timerInit = 'true';

      const hoursEl = timer.querySelector('[data-hours]');
      const minutesEl = timer.querySelector('[data-minutes]');
      const secondsEl = timer.querySelector('[data-seconds]');

      if (!hoursEl || !minutesEl || !secondsEl) return;

      let remainingSeconds = 59 * 60 + 59;

      function updateTimer() {
        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        hoursEl.textContent = formatTimerValue(hours);
        minutesEl.textContent = formatTimerValue(minutes);
        secondsEl.textContent = formatTimerValue(seconds);

        if (remainingSeconds <= 0) {
          clearInterval(timerInterval);
          return;
        }

        remainingSeconds -= 1;
      }

      updateTimer();

      const timerInterval = setInterval(updateTimer, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaleBannerCountdown();
    });
  } else {
    initSaleBannerCountdown();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaleBannerCountdown(event.target);
  });
})();